"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportLoadStart = exports.fedopsLogger = void 0;
var fedops_logger_1 = require("@wix/fedops-logger");
var InteractionName_1 = require("../../types/InteractionName");
var isMonitoringEnabled_1 = require("../isMonitoringEnabled");
var constants_1 = require("./constants");
var noop = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return null;
};
var createMockLogger = function () { return ({
    appLoaded: noop,
    interactionEnded: noop,
    interactionStarted: noop,
}); };
exports.fedopsLogger = isMonitoringEnabled_1.isMonitoringEnabled()
    ? fedops_logger_1.create(constants_1.FEDOPS_LOGGER_ID)
    : createMockLogger();
exports.reportLoadStart = function () {
    exports.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE);
    exports.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE_KICKOFF);
};
//# sourceMappingURL=index.js.map